import "./Backdrop.scss"
function Backdrop(props: any) {
    return <div className='backdrop' onClick={props.onClick} />;
  }
  
  export default Backdrop;